// --------------------------------------------------------------
// Created On: 2025-03-14
// Author: Dimitra Weinstein
//
// Last Modified: 2025-10-27
// Modified By: Zachary Thomas
//
// Copyright 2025 © Cornell Pump Company, All Rights Reserved
// --------------------------------------------------------------

import React from "react";

// A single report in a list of reports.
export default function MemphisReportListRow(props: Props): Component {
  return (
    <div className="p-2" data-test="memphis-report-list-row">
      <span>{props.name}</span>
    </div>
  );
}

interface Props {
  reportMemphisId: number | null;
  name: string;
}
